<template>
        <div class="warp" ref="warp">
            <!-- 表格 -->
            <el-table
              ref="multipleTable"
              :data="tableData"
              tooltip-effect="dark"
              style="width: 100%"
              v-loading="loading"
              element-loading-text="请求中......"
              fit
              :height="bHeight"
              :header-cell-style="headerStyle"
              @sort-change="sortChange"
            >
                <el-table-column
                  label="序号"
                  type="index"
                  width="55"
                />
                <el-table-column
                  prop="userName"
                  show-overflow-tooltip
                  label="账号"
                />
                <el-table-column
                  prop="realName"
                  show-overflow-tooltip
                  label="姓名"
                />
                <el-table-column
                  prop="userTypeName"
                  show-overflow-tooltip
                  label="用户类型"
                />
                <el-table-column
                  prop="sourceName"
                  show-overflow-tooltip
                  label="账号来源"
                />
                <el-table-column
                  prop="phone"
                  show-overflow-tooltip
                  label="手机号"
                />
                <el-table-column
                  prop="companyName"
                  show-overflow-tooltip
                  label="企业名称"
                />
                <el-table-column
                  prop="loginLockTime"
                  show-overflow-tooltip
                  sortable
                  label="锁定时间"
                />
                <el-table-column
                  prop="createTime"
                  show-overflow-tooltip
                  sortable
                  label="创建时间"
                />
                <el-table-column
                  label="操作"
                  width="100"
                >
                  <template slot-scope="{row}">
                    <el-button
                      size="small"
                      type="primary"
                      class="super"
                      plain
                      @click="setUser(row)"
                    >解锁</el-button>
                  </template>
                </el-table-column>
            </el-table>
            <!-- 分页 -->
            <div class="pagination" ref="pagination">
                <el-pagination
                  @size-change="handleSizeChange"
                  @current-change="handleCurrentChange"
                  :current-page="sendInfo.currentPage"
                  :page-sizes="[5, 10, 15, 20]"
                  :page-size="sendInfo.pageSize"
                  layout="total, sizes, prev, pager, next, jumper"
                  :total="totalPage"
                />
            </div>
        </div>
</template>

<script>
export default {
  data() {
    return {
      sendInfo: {
        pageSize: 10,
        currentPage: 1,
        property: null,//排序字段
        direction: null,//排序方式
      },
      tableData: [],
      totalPage: 0,
      bHeight: void 0,
      loading: false
    }
  },
  mounted() {
    const that = this
    that.getData();
    let bh = 44 + (that.$refs.condition?that.$refs.condition.offsetHeight:0) +  (that.$refs.pagination?that.$refs.pagination.offsetHeight:0) + 25
    that.bHeight = document.body.clientHeight - 64  - bh 
    that.doLayout()
    window.onresize = () => {
      return (() => {
        that.$nextTick(() => {
            bh = 44 + (that.$refs.condition?that.$refs.condition.offsetHeight:0) +  (that.$refs.pagination?that.$refs.pagination.offsetHeight:0) + 25
            that.bHeight = document.body.clientHeight - 64  - bh 
            that.doLayout()
        })
      })()
    }
  },
  methods: {
    /* 设置解锁 */
    setUser({id}) {
      const that = this
      that.$confirm('此操作将解锁该账户, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async() => {
        try {
          const { code, msg } = await that.$axiosz.put(`backstage/sysUser/unlockLogin/${id}`)
          if (code !== 200) return that.$message.info(msg)
          that.$message.success(msg)
          that.getData()
        } catch (error) {
          that.getData()
        }
      }).catch(() => {
        that.$message({
          type: 'info',
          message: '已取消解锁'
        })          
      })
    },
    /* 获取列表数据 */
    getData() {
      const that = this
      that.loading = true
      that.$axiosz.get(`backstage/sysUser/loginLockList`,{ params: that.sendInfo }).then((r) => {
        that.loading = false
        if (r.code == 200) {
          that.tableData = r.data.content;
          that.totalPage = r.data.totalElements;
        } else {
          that.$alert(r.msg)
        }
      }).catch(() => {
        that.loading = false
      })
    },
    //切换每页显示条数
    handleSizeChange(val) {
      this.sendInfo.pageSize = val;
      this.getData();
    },
    //切换页码
    handleCurrentChange(val) {
      this.sendInfo.currentPage = val;
      this.getData();
    },
    //表格排序事件
    sortChange({column, prop, order}) {
      if (order == 'ascending') {
        order = 'asc';
      } else {
        order = 'desc';
      }
      this.sendInfo.property = prop;
      this.sendInfo.direction = order;
      this.getData();
    },
    // 表头样式回调
    headerStyle() {
      return 'backgroundColor:#F7F7F7;fontSize:14px;color:#595959;fontWeight:500;padding:0;line-height:40px'
    },
    doLayout() {
      this.$nextTick(() => {
        if (this.$refs.multipleTable && this.$refs.multipleTable.doLayout) {
          this.$refs.multipleTable.doLayout()
        }
      })
    },
  }
}
</script>

<style scoped="scoped" lang="scss">
    .forms {
        .child {          
            .remark {
                /deep/ .el-textarea__inner {
                    min-height: 122px !important;
                }
            }
            .name {
                width: 123px;
                text-align: right;
            }
            .content{
              .el-input{
                max-width:400px !important;
              }
            }
        }
        .hint{
          margin-top:40px !important
        }
    }
    .left{
      .child{
        margin-top:0 !important;
      }
    }
.detail{
   padding:20px;
  .step{
    &_title{
      font-size: 14px;
      font-weight: 600;
      color:#666;
    }
    &_desc{
      font-size: 12px;
      color:#999;
      margin-top:5px;
    }
    &_tip{
      width:100%;
      height: 78px;
      background: rgba(255, 245, 230, 1);
      border: 1px solid rgba(255, 235, 204, 1);
      border-radius: 5px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      padding-left:20px;
      margin-top:20px;
      &_title{
        font-size: 14px;
        color:#666;
      }
    }
    &_error{
      &_title{
        font-size: 13px;
        font-weight: 700;
        color: #666;
        span{
          color: #19BE6B;
          font-weight: 400;
        }
        .red{
          color: red;
        }
      }
      &_lists{
        border:1px solid #ccc;
        background: rgba(249, 249, 249, 1);
        padding:20px;
        &_title{
          font-size: 14px;
          font-weight: 700;
          line-height: 24px;
        }
        &_item{
          font-size: 12px;
          line-height: 20px;
          margin-top:10px;
        }
      }
    }
  }
  .step_success{
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-items: center;
      justify-content:center;
      min-height:300px;
      .el-icon-success{
        font-size: 48px;
        color:#67c23a;
      }
      &_title{
        font-size: 16px;
        margin-top:20px;
        font-weight: bold;
      }
      &_info{
        margin-top:10px;
        font-size: 14px;
      }
  }
  .step_percentage{
    min-height: 400px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    .el-progress{
      width:100%;
    }
    &::v-deep{
      .el-progress__text{
        position:absolute;
        top:-25px;
        left:48%;
      }
    }
    &_tip{
      margin-top:20px;
      text-align: center;
      color:#888;
    }
  }
}
::v-deep{
  .el-tab-pane{
    .el-button{
      width:10%;
      margin-bottom:5px;
    }
    .el-button+.el-button{
      margin-left:0;
    }
  }
  .el-icon-dot{
  width:15px;
  height: 15px;
  border-radius: 50%;
  background: #ccc;
}
.is-finish{
  .el-icon-dot{
    background:$primary;
  }
}
.el-step__icon.is-icon{
  width:15px;
}
.el-step__title{
  font-size: 12px;
}
.el-descriptions-item__label{
  vertical-align:middle;
  text-align: center !important;
  width:10% !important;
}

}
.super_radio{
  display: block;
  width:80%;
  margin:0 auto;
  .el-radio{
    width:120px;
    margin-bottom:10px;
  }
  .el-radio:nth-child(3n){
    margin-right: 0 !important;
  }
}
</style>